import { Modal, Typography } from 'antd'
import { FormlessModalProps } from './types'

const FormlessModal: React.FC<FormlessModalProps> = ({
  title,
  height,
  narrow,
  width: propWidth,
  children,
  cancel,
  ok,
  ...rest
}) => {
  let maxHeight: number = 500
  if (height === 'tall') maxHeight = 750
  else if (height === 'short') maxHeight = 400

  let width: string | undefined = '60vw'
  if (narrow) width = undefined
  else if (propWidth === 'narrow') width = undefined
  else if (propWidth === 'wide') width = '90vw'

  return (
    <Modal
      {...rest}
      title={
        typeof title === 'string' ? (
          <Typography.Text>{title}</Typography.Text>
        ) : (
          title
        )
      }
      destroyOnClose
      onCancel={cancel?.fn}
      cancelButtonProps={{ ...cancel?.props }}
      okButtonProps={
        ok === false ? { style: { display: 'none' } } : { ...ok?.props }
      }
      onOk={ok === false ? undefined : ok.fn}
      confirmLoading={ok === false ? undefined : ok.loading}
      okText={ok === false ? undefined : ok.title ?? 'Ok'}
      okType={ok === false ? undefined : ok.type}
      width={width}
      maskClosable={false}
      bodyStyle={{
        padding: '2rem 2rem',
        overflowY: 'auto',
        maxHeight: maxHeight,
        overflowX: 'clip',
      }}
    >
      {children}
    </Modal>
  )
}

export default FormlessModal
